module.exports = __webpack_public_path__ + "static/media/dashboardMarge_en.2daff9bf.png";